import builder from '../builder';
import LoveIt from '../../streamline-icons/bold/love-it.svg';

export default builder('IconLoveItBold', LoveIt);
